export default __webpack_public_path__ + "static/media/5.619cd5cd.png";